<template>
  <div class="wdw-forum-create-comment" :class="'topic-' + topic.id">
    <template v-if="!topic">
      <loading loadingMessage="Formular wird geladen..." />
    </template>

    <template v-else>
      <template v-if="showForm">
        <wdw-dynbox>
          <comment-form
            :thoughtid="thought.id"
            :topicid="topic.id"
            @comment-form-close="closeCommentForm"
            @comment-updated="onCommentCreated"
          />
        </wdw-dynbox>
      </template>
      <template v-else>
        <p>Fehler, bitte Loggen Sie sich zunächst ein</p>
      </template>
    </template>
  </div>
</template>

<script>
import { onBeforeMount, computed, toRef } from 'vue';

// components
import Loading from '@/components/general/Loading.vue';
import CommentForm from '@/components/forum/elements/CommentForm.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';

// composables
import useTopicConfig from '@/composables/topic/useTopicConfig';

export default {
  name: 'forum-create-thought',
  props: {
    topic: {
      type: Object,
      required: true,
    },
    thought: {
      type: Object,
      required: true,
    },
  },
  emits: ['show-thought', 'push-message', 'clear-messages'],
  setup(props, context) {
    const topic = toRef(props, 'topic');
    const thought = toRef(props, 'thought');

    const { canCommentOnThoughts } = useTopicConfig();

    //
    //-----------------COMPUTED------------------
    //

    const showForm = computed(() => {
      return topic.value && canCommentOnThoughts(topic.value);
    });

    //
    //-----------------METHODS------------------
    //
    function closeCommentForm() {
      context.emit('show-thought', {
        thoughtid: thought.value.id,
        name: thought.value.title,
      });
    }
    function onCommentCreated(comment) {
      //new thought was created, go back to list view
      if (comment && comment.status === 'show') {
        context.emit('push-message', {
          severity: 'success',
          content: 'Beitrag wurde erfolgreich erstellt. Sie werden jetzt über neue Beiträge zum Thema informiert.',
        });
      } else {
        context.emit('push-message', {
          severity: 'success',
          content: 'Beitrag wird noch geprüft',
        });
      }
      context.emit('show-thought', {
        thoughtid: thought.value.id,
        name: thought.value.title,
      });
    }

    // initialization
    onBeforeMount(() => {
      // reset any messages on new thought
      context.emit('clear-messages');
    });

    return {
      // COMPUTED
      showForm,

      // METHODS
      closeCommentForm,
      onCommentCreated,
    };
  },

  components: {
    Loading,
    CommentForm,
    WdwDynbox,
  },
};
</script>
